import { render, staticRenderFns } from "./loading4-component.vue?vue&type=template&id=225cdb72&lang=html"
import script from "./loading4-component.vue?vue&type=script&lang=js"
export * from "./loading4-component.vue?vue&type=script&lang=js"
import style0 from "./loading4-component.vue?vue&type=style&index=0&id=225cdb72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports